import { GetResponseType, TokenResponseType } from '../types';
import useApi from '../hooks/useApi';
import { AUTH_TOKEN, WITH_AUTH } from 'app/constants';

export const verifyEmail = async (token: string): Promise<GetResponseType<TokenResponseType>> => {
  const { data, error, loading, httpCode } = await useApi(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/auth/email-confirmed`,
    'POST',
    null,
    {},
    WITH_AUTH,
    token
  );

  if (data && data.token) {
    localStorage.setItem(AUTH_TOKEN, data.token);
  }

  return {
    data,
    httpCode,
    error,
    loading
  };
};
